
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import { murakamiMasanori } from "@src/constants/authors";
import { ginzaKazamiKzamiTopImage } from "@src/constants/images";
export const meta = {
  path: "/media/ginza/vomero",
  title: "【銀座駅徒歩3分】銀座風見の酒粕で作る人気ラーメン",
  description: "ラーメンの激戦区「銀座」で他店には類をみない「酒粕」でダシをとるラーメン店「銀座風見」についてご紹介します。コロナ前後の行列情報や、ラーメンの特徴、そして酒粕以外の豊富なメニューについて、写真付きで掲載しております。まだ知らない方も、既に知っている方にも参考になる情報になりますので、是非ご確認下さい。",
  topImg: ginzaKazamiKzamiTopImage,
  author: murakamiMasanori,
  tags: ["銀座", "有名店", "ラーメン", "人気店", "お店の紹介", "食べログ高評価"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`銀座から徒歩 3 分の人気ラーメン店「銀座風見」。`}</p>
    <p>{`他のお店では堪能できない「酒粕」ラーメンは、ダシだけでなく麺や食材にも美味しさの秘密が。`}</p>
    <p>{`また、酒粕ラーメンだけでなく、季節限定や日替わりのメニューなど豊富に取り揃えられているのが特徴。`}</p>
    <p>{`大人気のラーメン店だからこそ、気になる行列情報も併せてご紹介しますので、是非ご覧になってください。`}</p>
    <h2>{`銀座風見とは？`}</h2>
    <InstaImage postId="CDqie-SpQIj" mdxType="InstaImage" />
    <p>{`銀座駅から徒歩 3 分という好アクセスの場所に位置する銀座でも大人気のラーメン店。
2016 年にオープンし、2017 年にはカップラーメンを出すほどのスピードで、一躍日本でも有名なお店として知られている。`}</p>
    <p>{`特に他店では見ないダシを使ったラーメンが話題となっており、
一過性で終わらず、`}<strong parentName="p">{`食べログの評価は 3.73`}</strong>{`を超え、ずっと人気のお店として銀座の人気ラーメン店。`}</p>
    <hr></hr>
    <h2>{`行列情報`}</h2>
    <InstaImage postId="CCvmrkzBxXU" mdxType="InstaImage" />
    <p>{`銀座の中では大人気のお店なので、行列ができることが多い。
特にコロナ前の時期は、お客様の半分は外国人だったようで、大行列ができることも多かったそうです。`}</p>
    <p>{`コロナ以降は少し数が減っているため、狙い目のタイミングも多く、
行列に並ばずにお店に入れることが多いので、是非お越しください！`}</p>
    <hr></hr>
    <h2>{`酒粕を使ったラーメン`}</h2>
    <h3>{`酒粕濃厚そば`}</h3>
    <InstaImage postId="CE39d7CJvEc" mdxType="InstaImage" />
    <p>{`店内だけでなくラーメンが運ばれてきた時には、酒粕の甘い香りを感じることができる白湯ベースのスープは、驚くほど濃厚でトロトロの口触りなのが特徴。`}</p>
    <p>{`味玉やほうれん草がスープに染み込んでくると、また違った味を楽しめるのが風見の酒粕ラーメン。`}</p>
    <h3>{`スープに負けない食材`}</h3>
    <InstaImage postId="CEQ8ctqJdSa" mdxType="InstaImage" />
    <p>{`特注で作った太麺の麺が、トロトロのスープにしっかり混ざり合い、酒粕の香りと風味に負けないくらいの存在感を出していて、歯応えも抜群。`}</p>
    <p>{`豚バラで作ってあるチャーシューは、薄くスライスされていて食べやすく、低温調理された柔らかい食感が特徴的です。`}</p>
    <hr></hr>
    <h2>{`豊富なメニュー`}</h2>
    <p>{`風見に何度も訪れたくなるのは、酒粕ラーメンだけでなく、豊富なメニューがあることです。
季節限定のラーメンや、日替わりで変わるメニューなど、行くたびに違った風見を楽しめます！`}</p>
    <h3>{`牡蠣そば`}</h3>
    <InstaImage postId="B3Ch5KOAhET" mdxType="InstaImage" />
    <h3>{`夏限定：あさりとしじみの梅冷やしそば`}</h3>
    <InstaImage postId="BmrfZKLlXUf" mdxType="InstaImage" />
    <h3>{`気まぐれご飯`}</h3>
    <InstaImage postId="BkgdV02FefU" mdxType="InstaImage" />
    <h3>{`キノコの和風つけ麺`}</h3>
    <InstaImage postId="CBAhp4HJaiW" mdxType="InstaImage" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`銀座のラーメンの名店、銀座風見についてご紹介してきましたがいかがでしょうか。
酒粕ラーメンをご存知の方も、季節限定のメニューなど豊富なメニューがあることも知っていただき、当日はいろんな選択肢を考えて、何度も何度も通っていただければと思います。`}</p>
    <ShopInfoBox shopId="btf2dui23akg00ddbgng" mdxType="ShopInfoBox" />

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;